import { createAction, props } from '@ngrx/store';

import { Entity, User } from '@apps/auth/domain/models/back';
import { PartialUser, PartialEntity } from '@apps/back/models';

export const BackEntityDetailsInMemorySaveRequested = createAction(
    '[BACK-ENTITY] Back Entity Details InMemory Save Requested',
    props<{ entity: PartialEntity }>()
);

export const BackUserDetailsSaveRequested = createAction(
    '[BACK-USER] Back User Details Save Requested',
    props<{ user: PartialUser }>()
);

export const BackEntityDetailsSelectSet = createAction(
    '[BACK-ENTITY] Back Entity Details Select Set',
    props<{ entity: Entity }>()
);

export const BackEntityDetailsWasSelected = createAction(
    '[BACK-ENTITY] Back Entity Details Was Selected',
    props<{ entity: PartialEntity }>()
);

export const BackUserDetailsLoadRequested = createAction(
    '[BACK-USER] Back User Details Load Requested',
    props<{ user: User }>()
);

export const BackUserDetailsLoadSucceeded = createAction(
    '[BACK-USER] Back User Details Load Succeeded',
    props<{ user }>()
);
